export default function navigation() {

  $('.hamburger').click (function(){
    $(this).toggleClass('active');
    $('.overlay').toggleClass('open');
  });

  $('.header-navigation__item').click(function(){
    $(this).toggleClass('open');
    $('.header-navigation__item').not(this).removeClass('open');
  });

}



// WEBPACK FOOTER //
// ./scripts/modules/navigation.js